import { Allocation } from 'common/types/allocation';
import { ReducerAction, ReducerState } from 'common/types/reducers';

export const setAllocationInfo = (
  state: ReducerState,
  action: ReducerAction<{ allocationInfo: Partial<Allocation> }>
) => ({
  ...state,
  ...action,
});
